<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="assign-licenses" appLifecycleTracker trackerName="assign-licenses">
    <div *ngIf="!(isLoading$ | async)">
        <span class="licenses-loaded"></span>
    </div>

    <div class="table-header">
        <h2 class="table-title">
            <button mat-mini-fab color="primary" routerLink="/products" id="close-details"
                    aria-label="Go back to products page." [ngStyle]="{transform: 'scale(0.7)'}">
                <span class="mdi mdi-arrow-left left-icon"></span>
            </button>
            <span>{{'assign.pba.title' | translate}}</span>
        </h2>
        <div class="buttons-wrapper">
            <button *ngIf="this.isMsp" id="add-serial" type="button" mat-button (click)="showAddSerialDialog()"
                    color="primary" mat-raised-button><span class="mdi mdi-desktop-classic"></span>
                {{'assign.pba.add-serial-button-title' | translate}}...
            </button>
            <button *ngIf="this.isMsp" id="generate" [disabled]="!pendingDrivesSelected" type="button" mat-button
                    (click)="showGenerateDialog()" color="primary"
                    mat-raised-button><span class="mdi mdi-key"></span>
                {{'assign.generate.title' | translate }}...
            </button>
            <button type="button" id="upload" mat-button (click)="showEnterOrUploadCodeDialog()" color="primary"
                    mat-raised-button><span class="mdi mdi-form-select"></span>
                {{'assign.pba.upload-button-title' | translate }}...
            </button>
            @if (this.isMsp) {
                <button mat-raised-button [matMenuTriggerFor]="actionMenu" class="mdi mdi-dots-horizontal" color="primary" role="link"></button>
                <mat-menu #actionMenu="matMenu">
                    <button id="delete-serial" [disabled]="checkedDrives.length != 1 || checkedDrives[0]?.pba_license_id" type="button" (click)="showDeleteSerialDialog()" mat-menu-item>{{'assign.pba.delete-serial-button-title' | translate}}</button>
                    <button type="button" [disabled]="checkedDrives.length == 0" id="batch-update" (click)="showBatchUpdateCustomDialog()" mat-menu-item>{{'assign.pba.batch-update-custom-button-title' | translate }}</button>
                </mat-menu>
            }
        </div>
    </div>

    <div class="table-panel">
        <div class="assigned-count">
            <span>{{licenses_available}}</span>
            <span *ngIf="isMsp" style="display: flex">
                <hr class="vertical">
                <span class="pbainfo-label">{{'assign.details.raid' | translate}}:</span>
                <span>{{ raid === true ? ('ENABLED' | translate) : ('DISABLED' | translate) }}</span>
                <hr class="vertical">
                <span class="pbainfo-label">{{'products.pba-extended-features' | translate}}:</span>
                <span>{{ enable_pba_extended_features === true ? ('ENABLED' | translate) : ('DISABLED' | translate) }}</span>
                <hr class="vertical">
                <span class="pbainfo-label">{{'products.pba-cmd-log' | translate}}: </span>
                <span>{{ enable_pba_log_erase === true ? ('ENABLED' | translate) : ('DISABLED' | translate) }}</span>
            </span>
        </div>

        <div class="cigent-box">
            <div class="header-container">
                <div *ngIf="licensedDrives != null" id="totalEndpoints" class="license-total">
                    <b>{{pbaLicensesCount}} {{ 'assign.pba.count_label' | translate }}</b>
                    ({{'assign.shown-selected' | translate : {total: totalShown, selected: totalSelected} }})
                </div>
                <div>
                    <mat-button-toggle-group [value]="null" appearance="standard" (change)="setButtonToggle($event)"
                                             hideSingleSelectionIndicator="true">
                        <mat-button-toggle [value]="null">All</mat-button-toggle>
                        <mat-button-toggle [value]="true">Assigned</mat-button-toggle>
                        <mat-button-toggle [value]="false">Unassigned</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <app-column-chooser saveId="pba-licenses" [elements]="columns" (change)="updateDisplayedColumns($event)">
                </app-column-chooser>
            </div>
                <div class="filters-container">
                    @if (columnsToDisplay.includes("custom_text_1")) {
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>{{'assign.pba.custom-text-1' | translate}}</mat-label>
                            <mat-chip-grid #chipGrid1 aria-label="Enter filters">
                                @for (filter of custom1Filters; track filter) {
                                    <mat-chip-row
                                            (removed)="removeCustomFilter(custom1Filters, filter)"
                                            [editable]="true"
                                            (edited)="editCustomFilter(custom1Filters, filter, $event)"
                                            [aria-description]="'press enter to edit ' + filter">
                                        {{filter}}
                                        <button matChipRemove [attr.aria-label]="'remove ' + filter">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                                <input placeholder="New filter..."
                                       [matChipInputFor]="chipGrid1"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       [matChipInputAddOnBlur]="true"
                                       (matChipInputTokenEnd)="addCustomFilter(custom1Filters, $event)"/>
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>
                    }
                    @if (columnsToDisplay.includes("custom_text_2")) {
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>{{'assign.pba.custom-text-2' | translate}}</mat-label>
                            <mat-chip-grid #chipGrid2 aria-label="Enter filters">
                                @for (filter of custom2Filters; track filter) {
                                    <mat-chip-row
                                            (removed)="removeCustomFilter(custom2Filters, filter)"
                                            [editable]="true"
                                            (edited)="editCustomFilter(custom2Filters, filter, $event)"
                                            [aria-description]="'press enter to edit ' + filter">
                                        {{filter}}
                                        <button matChipRemove [attr.aria-label]="'remove ' + filter">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                                <input placeholder="New filter..."
                                       [matChipInputFor]="chipGrid2"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       [matChipInputAddOnBlur]="true"
                                       (matChipInputTokenEnd)="addCustomFilter(custom2Filters, $event)"/>
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>
                    }
                </div>
        </div>
        <div class="table-container"
             id="licensestable"
             infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="50"
             (scrolled)="onScrollHandler($event)"
             [alwaysCallback]="true"
             [scrollWindow]="false">
            <table mat-table [dataSource]="licensedDrives" matSort matSortDisableClear='true'
                   [matSortActive]="sortAttr" [matSortStart]="'desc'" [matSortDirection]="sortDir"
                   (matSortChange)="sortColumn($event)" aria-label="Assigned license details, including adding serial numbers and generating license keys">
                <ng-container *ngIf="isMsp" matColumnDef="checkbox">
                  <th scope="col" mat-header-cell *matHeaderCellDef>
                      <mat-checkbox [(ngModel)]="selectAllChecked" (click)="selectAll($event)"
                                    aria-label="select/deselect all"></mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let drive">
                      <mat-checkbox [(ngModel)]="drive.checked" (click)="checkSelectAllLater(drive, $event)"
                                    aria-label="select {{drive.disk_serial}}"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="disk_serial">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>
                        <mat-form-field subscriptSizing="dynamic" (click)="$event.stopPropagation()" class="cmp-name-search" appearance="outline">
                            <mat-label>{{'assign.pba.serial' | translate}}</mat-label>
                            <input matInput type="search" (click)="$event.stopPropagation()"
                                   placeholder="{{'assign.pba.serial' | translate}}" maxlength="255"
                                   [(ngModel)]="ssdSerialNumberSearch" (keydown.space)="$event.stopPropagation()"
                                   appDebounceInput (debounceInput)="getLicensedDrives()" debounceTime="750">
                        </mat-form-field>
                    </th>
                    <td mat-cell *matCellDef="let drive" id="serial"
                       >
                      {{ drive.disk_serial }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="custom_text_1">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>
                        {{'assign.pba.custom-text-1' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive; let i = index;"  id="custom_text_1"
                       >
                        <mat-form-field appearance="outline" subscriptSizing="dynamic" matRipple
                                        [matRippleColor]="rippleColor" [matRippleDisabled]="true">
                          <input matInput type="text" maxlength="128" [(ngModel)]="drive.custom_text_1"
                                 matTooltip="{{drive.custom_text_1}}" matTooltipPosition="below"
                                 [matTooltipDisabled]="drive?.custom_text_1?.length < 20" [tabIndex]="i+1"
                                 (change)="onCustomTextBlur(drive, i, $event)" name="CustomText1">
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef="custom_text_2">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>
                        {{'assign.pba.custom-text-2' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive; let i = index;"  id="custom_text_2"
                       >
                        <mat-form-field appearance="outline" subscriptSizing="dynamic" matRipple
                                        [matRippleColor]="rippleColor" [matRippleDisabled]="true">
                          <input matInput type="text" maxlength="128" [(ngModel)]="drive.custom_text_2"
                                 matTooltip="{{drive.custom_text_2}}" matTooltipPosition=below
                                 [matTooltipDisabled]="drive?.custom_text_2?.length < 20"
                                 [tabIndex]="(licensedDrives.data.length*2)+i+1"
                                 (change)="onCustomTextBlur(drive, i, $event)" name="CustomText2">
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="created_dttm">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>{{'assign.pba.created' | translate}}</th>
                    <td mat-cell *matCellDef="let drive" id="created_dttm">
                        <span>{{drive.created_dttm | date: 'medium'}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="last_generated">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>{{'assign.pba.last_generated' | translate}}</th>
                    <td mat-cell *matCellDef="let drive" id="last-generated">
                        <span>{{drive.last_generated | date: 'medium'}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="pba_license_id">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>{{'assign.pba.license_id' | translate}}</th>
                    <td mat-cell *matCellDef="let drive" id="pba-key">
                        <span>{{drive.pba_license_id}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="pba_license_maint_end">
                    <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef>{{'assign.columns.maintenance-date' | translate}}</th>
                    <td mat-cell *matCellDef="let drive">
                        <span>{{drive?.pba_license?.maint_exp_timestamp | date}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="license_key">
                    <th scope="col" mat-header-cell *matHeaderCellDef>{{'assign.pba.license_key' | translate}}</th>
                    <td mat-cell *matCellDef="let drive" id="license-key">
                        @if (drive.pba_license) {
                            <span class="mdi mdi-tray-arrow-down icon clickable"
                                  matTooltip="{{'assign.pba.download_response_code_tooltip' | translate}}"
                                  (click)="create_download_file(drive)" matTooltipPosition="below">
                            </span>
                            <span id="copyResponseCodeButton" class="mdi mdi-content-copy icon clickable"
                                  matTooltip="{{'assign.pba.copy_response_code_tooltip' | translate}}" matTooltipPosition="below"
                                  (click)="onCopyResponseCode(drive.pba_license.license_key, drive.pba_license.id)">
                            </span>
                            <span id="detailsButton" class="mdi mdi-text-box-search-outline icon clickable"
                                  matTooltip="{{'assign.details.tool-tip' | translate}}"
                                  (click)="showDetailsDialog(drive.disk_serial)" matTooltipPosition="below">
                            </span>
                        }
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>

            </table>
            <div *ngIf="licensedDrives.data.length == 0" class="paging-span" style="height: 100px;"  id="nodata">
                <span class="no-licenses">{{ 'assign.pba.no_licenses' | translate }}</span>
            </div>
        </div>
    </div>
</div>
